module.exports = __webpack_public_path__ + "img/company.0fc67ab8.png";